import { render, staticRenderFns } from "./ppnCards.vue?vue&type=template&id=0de90c50&scoped=true&"
import script from "./ppnCards.vue?vue&type=script&lang=js&"
export * from "./ppnCards.vue?vue&type=script&lang=js&"
import style0 from "./ppnCards.vue?vue&type=style&index=0&id=0de90c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de90c50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/vuetify_1/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VCheckbox,VContainer,VDataTable,VIcon})
